import type { PropsWithChildren, ReactNode } from 'react';

interface PanelProps {
  title?: string;
  /** Icon rendered before the title (e.g. the broadcast icon on Stream Status). */
  titleIcon?: ReactNode;
  /** Icon/control rendered after the title, right-aligned (e.g. the info icon). */
  titleAccessory?: ReactNode;
  className?: string;
}

export function Panel({
  title,
  titleIcon,
  titleAccessory,
  className = '',
  children,
}: PropsWithChildren<PanelProps>) {
  return (
    <section
      className={`rounded-xl border border-surface-border bg-surface-1 p-5 shadow-panel ${className}`}
    >
      {title && (
        <header className="mb-4 flex items-center justify-between">
          <div className="flex items-center gap-2">
            {titleIcon}
            <h2 className="text-xs font-semibold tracking-wide text-accent">{title}</h2>
          </div>
          {titleAccessory}
        </header>
      )}
      {children}
    </section>
  );
}
